export default __webpack_public_path__ + "static/media/LVZ WEB ICONS - LANGUAGES.37c6b0cf.svg";